//This threshold values are used for determining response of backend part against the data scale requested by user.
// Data Scale Formula = Indicators*Countries*Years ==> Every variable represent their length values.
export const MAX_THRESHOLD = 1000000;
export const MID_THRESHOLD = 600000;
export const MIN_THRESHOLD = 200000;